import React from 'react'
import PropTypes from 'prop-types'
import { maxBy, some, take } from 'lodash'
import i18n from 'simple-react-i18n'
import DtoFile from './dto/DtoFile'
import { capitalizeFirstLetter } from '../../utils/StringUtil'
import { getDocumentTypeIcon, getFileExtension } from 'utils/FileUtils'
import Fancybox from 'components/fancybox/Fancybox'
import { Card, CardContent, Grid, Icon, Tooltip } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import { PICTURES_EXTENSIONS } from './constant/FileConstants'

const FilePanel = ({
    files = [],
    showLast = false,
    editable = false,
    deleteFile,
    hideTitle = false,
    onShowMore = () => {},
}) => {
    const fileDelete = (file) => {
        const fileToDelete = {
            name: file.url.split('/DOCUMENTS/')[1],
            fileType: 'document',
        }
        deleteFile(fileToDelete)
    }

    const create = file => {
        const nameFormat = file.isAllDataName ? capitalizeFirstLetter(file.shortName) : file.name
        const fileExtension = getFileExtension(file.name)
        return (
            <Grid size={6}>
                { editable ? (
                    <span onClick={ () => fileDelete(file) } style={ {
                        marginRight: '10px',
                        color: 'red',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    } }
                    >X</span>
                ) : '' }
                <Fancybox>
                    <a style={{ border: 'solid 2px black', borderRadius: '5px', padding: '5px' }} href={ file.url } target='_blank' data-caption={ nameFormat } className='valign-wrapper'>
                        <img src={ getDocumentTypeIcon(fileExtension) } style={{ maxWidth: '15px', height: 'auto' }} />
                        <b className='font-size-10 truncate clickable padding-left-1'>{ nameFormat }</b>
                    </a>
                </Fancybox>
            </Grid>
        )
    }

    const componentfiles = (() => {
        const filterFiles = files.filter(f => !some(PICTURES_EXTENSIONS, extension => f.name.endsWith(extension)))
        if (showLast) {
            return filterFiles.length ? [create(maxBy(filterFiles, 'updateDate'))] : []
        }
        return filterFiles.map(f => create(f))
    })()

    const filesRemaining = (componentfiles.length - 5) > 9 ? '9_plus' : componentfiles.length - 5

    return componentfiles.length !== 0 && (
        <Card>
            {!hideTitle && <CardTitle title={i18n.files} />}
            <CardContent>
                <Grid container spacing={1} >
                    {take(componentfiles, 5)}
                    {componentfiles.length > 5 && (
                        <Grid container size={'grow'} justifyContent={'flex-end'} alignItems={'center'}>
                            <Tooltip title={i18n.viewMore}>
                                <Icon onClick={onShowMore} sx={{ cursor: 'pointer' }}>{`filter_${filesRemaining}`}</Icon>
                            </Tooltip>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    )
}

FilePanel.propTypes = {
    code: PropTypes.string,
    files: PropTypes.arrayOf(PropTypes.instanceOf(DtoFile)),
    showLast: PropTypes.bool,
    editable: PropTypes.bool,
    deleteFile: PropTypes.func,
    hideTitle: PropTypes.bool,
    onShowMore: PropTypes.func,
}

export default FilePanel